export const tablePaginate = {page: 1,page_size: 10}

